import { useState } from "react";
import { ChevronDown } from "lucide-react";

export default function FAQ({ data = [] }) {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="section-padding container-width">
      <h2 className="text-2xl md:text-3xl font-bold text-center mb-8">
        Frequently Asked Questions
      </h2>

      <div className="space-y-4">
        {data.map((item, index) => (
          <div
            key={index}
            className="rounded-[4px] shadow-md hover:shadow-xl transition-shadow duration-300 overflow-hidden mb-2"
          >
            <button
              onClick={() => toggle(index)}
              className="w-full flex items-center justify-between p-4 text-left"
            >
              <span className="font-medium text-sm md:text-base">
                {item.question}
              </span>
              <ChevronDown
                className={`transition-transform duration-300 ${
                  openIndex === index ? "rotate-180" : ""
                }`}
              />
            </button>

            <div
              className={`px-4 transition-all duration-300 ease-in-out text-sm md:text-base text-gray-600 ${
                openIndex === index
                  ? "max-h-40 py-2"
                  : "max-h-0 overflow-hidden"
              }`}
            >
              {item.answer}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

// Example Usage:
// const faqData = [
//   {
//     question: "What is your service?",
//     answer: "We provide automation solutions...",
//   },
//   {
//     question: "How can I contact support?",
//     answer: "You can reach us via email or chat.",
//   },
// ];

// <FAQ data={faqData} />
